export default {
    name: 'v5-icon-search',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M909.585 869.05L730.211 689.676c54.492-64.08 84.105-144.421 84.105-229.376 0-94.785-36.895-183.865-103.887-250.858-66.992-66.992-156.073-103.887-250.858-103.887S275.706 142.45 208.713 209.442C141.721 276.434 104.826 365.515 104.826 460.3s36.895 183.865 103.887 250.858c66.992 66.992 156.073 103.887 250.858 103.887 84.955 0 165.418-29.733 229.376-84.105l179.374 179.374c5.703 5.703 13.107 8.496 20.631 8.496s14.928-2.791 20.631-8.496c11.408-11.408 11.408-29.855 0-41.264zM249.978 670.015c-115.659-115.659-115.659-303.772 0-419.309 55.948-55.948 130.465-86.896 209.715-86.896s153.646 30.826 209.715 86.896c115.659 115.659 115.659 303.772 0 419.309-115.78 115.538-303.892 115.538-419.43 0z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
